import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08fcd2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button--container cursor-pointer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "font-gordita-medium text-Text/text_high ml-[4px]" }
const _hoisted_4 = {
  key: 1,
  class: "uil uil-angle-down text-[20px] text-Text/text_medium cursor-pointer"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times field-icon" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { IncrediMenu, IncrediButton } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { ref, inject, watch, onMounted } from 'vue';
import { WORKLOADS_DURATION_UNITS } from '@/views/workloads/workloads.const';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useMatomo } from '@/services/matomo/matomo.service';
import DurationMenu from './durationMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'durationFilter',
  emits: ["menu-visibility"],
  setup(__props, { emit }: { emit: ({
  (e: 'menu-visibility', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const matomo = useMatomo();
const workloadsPageData = inject(IKWorkloadsPageData);
const menuOpen = ref(false);
const durationLabel = ref('Duration');
const durationSelection = ref('');
const unitSelection = ref(WORKLOADS_DURATION_UNITS.Seconds);

const applySelection = (selection: { displayValue: string; unitSelection: WORKLOADS_DURATION_UNITS; filterValue: { from: number; to: number } }) => {
  durationSelection.value = selection.displayValue;
  unitSelection.value = selection.unitSelection;
  workloadsPageData?.filter?.setDuration(selection.filterValue);
  menuOpen.value = false;
  matomo?.trackEvent({
    category: 'Workloads Filter',
    action: 'Apply duration',
  });
};



const setMenuVisible = (value: boolean) => {
  menuOpen.value = value;
  emit('menu-visibility', value);
};

const resetDisplayValues = () => {
  durationSelection.value = '';
  unitSelection.value = WORKLOADS_DURATION_UNITS.Seconds;
};

const resetFilter = () => {
  resetDisplayValues();
  workloadsPageData?.filter?.setDuration({ from: null, to: null });
};

onMounted(() => {
  const { durationFrom, durationTo } = workloadsPageData?.filter?.get?.value || {};
  if (durationFrom == null && durationTo == null) {
    return;
  }
  durationSelection.value = `${durationFrom} - ${durationTo} sec`;
});

watch(
  () => [workloadsPageData?.filter?.get?.value?.durationFrom, workloadsPageData?.filter?.get?.value?.durationTo],
  ([newFrom, newTo]) => {
    if (newFrom === null && newTo === null) {
      resetDisplayValues();
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{ menuIsOpen: menuOpen.value, menuSelected: durationSelection.value }, "menu--container px-[8px]"])
      }, [
        _createVNode(_unref(IncrediMenu), {
          direction: "bottom-middle",
          "model-value": menuOpen.value,
          "onUpdate:modelValue": setMenuVisible
        }, {
          content: _withCtx(() => [
            _createVNode(DurationMenu, {
              "unit-selection": unitSelection.value,
              onSubmit: applySelection,
              onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (setMenuVisible(false)))
            }, null, 8, ["unit-selection"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IncrediButton), { design: "ghost-grey" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(durationLabel.value), 1),
                  (durationSelection.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, ": "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(durationSelection.value), 1),
                  (!durationSelection.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model-value"]),
        (durationSelection.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex ml-[6px] text-[14px]",
              onClick: resetFilter
            }, _hoisted_6))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})